<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Trash</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-9">
            <h3 class="page-title" style="float:left;">Trash</h3>
          </div>
        </div>
      </div>
    </div>
    <tabs class="tabs-default status-switch">
      <tab id="trashed-forms" name="Forms">
        <div class="row">
          <div class="col-xl-12">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Patient Name</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody v-if="forms.length">
                <tr
                  v-for="record in forms"
                  :key="record.id"
                >
                  <td>{{ record.id }}</td>
                  <td>{{ record.created_at }}</td>
                  <td>{{ record.form_type | capitalize }}</td>
                  <td>{{ record.patient_name }}</td>
                  <td>
                    <span v-if="record.status == 'new'" class="btn btn-xs btn-success">New</span>
                    <span v-else class="btn btn-xs btn-danger">Viewed</span>
                  </td>
                  <td>
                    <i
                      v-tooltip.top-center="'Restore'"
                      class="icon-im icon-im-spinner11 delete--link"
                      @click="restoreRecord('form', record.id)"
                    />
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">There is no trashed forms</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </tab>
      <tab id="trashed-categories" name="Categories">
        <div class="row">
          <div class="col-xl-12">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody v-if="categories.length">
                <tr v-for="type in categories" :key="type.id">
                  <td>{{ type.id }}</td>
                  <td>{{ type.title }}</td>
                  <td>
                    <span v-if="type.active" class="btn btn-xs btn-success">Active</span>
                    <span v-else class="btn btn-xs btn-danger">Inactive</span>
                  </td>
                  <td>
                    <i
                      v-tooltip.top-center="'Restore'"
                      class="icon-im icon-im-spinner11 delete--link"
                      @click="restoreRecord('category', type.id)"
                    />
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">There is no trashed categories</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </tab>
      <tab id="trashed-products" name="Products">
        <div class="row">
          <div class="col-xl-12">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Categories</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody v-if="products.length">
                <tr v-for="product in products" :key="product.id">
                  <td>{{ product.id }}</td>
                  <td>{{ product.title }}</td>
                  <td>{{ product.categories }}</td>
                  <td>
                    <i
                      v-tooltip.top-center="'Restore'"
                      class="icon-im icon-im-spinner11 delete--link"
                      @click="restoreRecord('product', product.id)"
                    />
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">There is no trashed products</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </tab>
      <tab id="trashed-users" name="Users">
        <div class="row">
          <div class="col-xl-12">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody v-if="users.length">
                <tr
                  v-for="record in users"
                  :key="record.id"
                >
                  <td>{{ record.id }}</td>
                  <td>{{ record.email }}</td>
                  <td>{{ record.roles_names | capitalize }}</td>
                  <td>
                    <i
                      v-tooltip.top-center="'Restore'"
                      class="icon-im icon-im-spinner11 delete--link"
                      @click="restoreRecord('user', record.id)"
                    />
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">There is no trashed users</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
/* global axios, toastr */
import { Tabs, Tab } from 'vue-tabs-component'

export default {
  name: 'TrashList',
  components: {
    tabs: Tabs,
    tab: Tab
  },
  data () {
    return {
      forms: [],
      categories: [],
      products: [],
      users: []
    }
  },
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/admin/trash')
      .then(response => {
        next(vm => {
          vm.forms = response.data.forms
          vm.categories = response.data.categories
          vm.products = response.data.products
          vm.users = response.data.users
        })
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.commit('setLoading', false)
  },
  methods: {
    restoreRecord (type, id) {
      let that = this

      axios
        .post('/api/admin/trash/' + type + '/' + id)
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            that.forms = response.data.forms
            that.categories = response.data.categories
            that.products = response.data.products
            that.users = response.data.users
            toastr['success']('Record has been restored successfully')
          } else {
            let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
            toastr['error'](message)
          }
        })
        .catch(error => {
          console.log(error)
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    }
  }
}
</script>

<style>
.delete--link:hover {
  cursor: pointer;
}
</style>
